import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useButton } from '@react-aria/button';
import { useEditor } from '@splashthat/splash-cms-engine';

import { SpeakerImage, SpeakerPlaceholder } from './SessionCard.styles';

export default function SessionAvatar({ src, firstName, lastName, fontFamily, onClickSpeakerAvatar, dataQa }) {
    const editor = useEditor((state) => ({ editing: state.editing }));
    const ref = useRef();
    const { buttonProps } = useButton(
        {
            onPress: onClickSpeakerAvatar,
            elementType: SpeakerImage,
            preventFocusOnPress: editor.editing,
        },
        ref,
    );
    const fullName = [firstName, lastName].filter(Boolean).join(' ');
    const firstInitial = (firstName || '')[0];
    const lastInitial = (lastName || '')[0];

    if (src) {
        return <SpeakerImage {...buttonProps} src={src} alt={fullName} ref={ref} data-qa={dataQa} />;
    } else if (firstName || lastName) {
        return (
            <SpeakerPlaceholder $fontFamily={fontFamily} {...buttonProps} ref={ref} data-qa={dataQa}>
                {firstInitial}
                {firstInitial && ' '}
                {lastInitial}
            </SpeakerPlaceholder>
        );
    } else {
        return null;
    }
}

SessionAvatar.propTypes = {
    src: PropTypes.string,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    fontFamily: PropTypes.string.isRequired,
    onClickSpeakerAvatar: PropTypes.func.isRequired,
    dataQa: PropTypes.string,
};

SessionAvatar.defaultProps = {
    src: '',
    dataQa: undefined,
};
